import { useState } from "react";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, List, Typography, Button, Spin } from "antd";
import { useHandleNotifications } from "../../hooks/useHandleNotifications";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../feature-module/router/all_routes";

const { Text } = Typography;

const Notification = () => {
  const [open, setOpen] = useState(false);
  const { moodleUser } = useAuth();
  const navigate = useNavigate();
  const { userNotifications, isUserNotificationsLoading } = useHandleNotifications(moodleUser?.id);

  const formatTime = (timestamp: string) => {
    const date = new Date(Number(timestamp) * 1000); // Convert string to number then to milliseconds
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    
    if (diffInSeconds < 60) return `${diffInSeconds} giây trước`;
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} phút trước`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} giờ trước`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)} ngày trước`;
    return date.toLocaleDateString('vi-VN');
  };

  // Lọc thông báo có eventtype
  const filteredNotifications = userNotifications?.messages?.filter(
    (notification: any) => notification.eventtype
  ) || [];

  const handleViewMore = (item: any) => {
    setOpen(false);
    navigate(all_routes.notification, {
      state: {
        item,
      },
    });
  };

  const content = (
    <div style={{ width: 360 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, padding: "0 16px" }}>
        <Text strong style={{ fontSize: 18 }}>Thông báo</Text>
      </div>

      {isUserNotificationsLoading ? (
        <div className="text-center py-4">
          <Spin />
        </div>
      ) : (
        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
          <List
            dataSource={filteredNotifications}
            renderItem={(item: any) => (
              <List.Item style={{ padding: "8px 20px" }}>
                <List.Item.Meta
                  avatar={<FontAwesomeIcon icon={faBell} style={{ fontSize: 12, color: "#1890ff", marginTop: 6 }} />}
                  title={<div style={{ fontSize: '14px', fontWeight: 400 }}>{item.subject}</div>}
                  description={
                    <div className="d-flex flex-row justify-content-between">
                      <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{formatTime(item.timecreated)}</div>
                      <Button
                        type="link"
                        style={{ padding: 0, height: "auto", fontSize: "12px" }}
                        onClick={() => handleViewMore(item)}
                      >
                        Xem thêm
                      </Button>
                    </div>
                  }
                />
              </List.Item>
            )}
            locale={{ emptyText: "Không có thông báo mới" }}
          />
        </div>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      placement="bottomRight"
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
    >
      <button
        className="btn py-0 px-1 btn-icon btn-light"
        type="button"
      >
        <FontAwesomeIcon icon={faBell} />
      </button>
    </Popover>
  );
};

export default Notification;
